export default "/kiban/_next/static/images/bottom_white-abc8b08888b053f481fbc8fdae38e737.png";